export const MULTI_SELECT_CONSTANTS = {
  ITEM_HEIGHT: 48,
  ITEM_PADDING_TOP: 8,
  MENU_PROPS: {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8 + 48, // ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP + 48
      },
    },
    MenuListProps: {
      style: {
        padding: 0,
      },
    },
  },
};
